import { axiosClient } from "./axiosClient"

export const PRODUCT_PATH = '/api/v1/product'

export const getAllProducts = ({ collectionId }) => {
    return axiosClient.get(`${PRODUCT_PATH}/all?collectionId=${collectionId}`)
}

export const addProduct = (body) => {
    return axiosClient.post(`${PRODUCT_PATH}`, body)
}

export const updateProduct = (id, body) => {
    return axiosClient.put(`${PRODUCT_PATH}/${id}`, body)
}

export const deleteProduct = (id) => {
    return axiosClient.delete(`${PRODUCT_PATH}/${id}`)
}

export const getPageProducts = ({ page = 0, collectionId = "", colorId = "", weightId = "", patternId = "", search = "", lastId = '', id = "", name = '' }) => {
    return axiosClient.get(`${PRODUCT_PATH}/page?page=${page}&collectionId=${collectionId}&colorId=${colorId}&weightId=${weightId}&patternId=${patternId}&search=${search}&lastId=${lastId}&id=${id}&name=${name}`)
}

export const uploadProductExcelFile = (body) => {
    return axiosClient.post(`${PRODUCT_PATH}/upload-excel`, body)
}